import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo/pencil.svg'
import _imports_1 from '@/assets/img/logo/share.svg'


const _withScopeId = n => (_pushScopeId("data-v-0ac30e01"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "w-full pt-40 justify-center items-start flex" }
const _hoisted_3 = {
  key: 1,
  class: "md:w-[768px] min-h-screen w-full -mt-4 sm:mt-0"
}
const _hoisted_4 = { class: "w-full flex justify-center items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-full bg-black opacity-40 rounded-full absolute top-0" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "8",
  height: "16",
  viewBox: "0 0 8 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "rotate-0"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.75 1.58317L1.25 7.99984L6.75 14.4165",
    stroke: "#fff",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-full bg-black opacity-40 rounded-full absolute top-0" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "8",
  height: "16",
  viewBox: "0 0 8 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "rotate-180"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.75 1.58317L1.25 7.99984L6.75 14.4165",
    stroke: "#fff",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "absolute top-0 w-full h-full rounded-md flex justify-center items-center text-white"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-full bg-black opacity-40 rounded-md" }, null, -1))
const _hoisted_13 = { class: "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-medium" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "w-full h-full flex justify-center" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))
const _hoisted_18 = { class: "flex justify-between w-full mt-4 px-4 sm:px-0" }
const _hoisted_19 = { class: "flex items-center mb-4" }
const _hoisted_20 = { class: "w-10 h-10 mr-2 rounded-full" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "w-4 mr-2 hidden sm:block"
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: ""
}, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "px-4 sm:px-0" }
const _hoisted_27 = { class: "flex w-full justify-between" }
const _hoisted_28 = { class: "text-lg mb-[3px]" }
const _hoisted_29 = {
  key: 0,
  class: "flex h-auto text-sm text-[#646669]"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "판매중", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "7" }, "예약중", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "9" }, "판매완료", -1))
const _hoisted_33 = [
  _hoisted_30,
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = { class: "text-xl font-semibold tracking-wide" }
const _hoisted_35 = { class: "infoBox space-y-2" }
const _hoisted_36 = { class: "flex" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "w-12 text-[#A4A4A4]" }, "종", -1))
const _hoisted_38 = { class: "text-[#676767]" }
const _hoisted_39 = { class: "flex" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "w-12 flex-shrink-0 text-[#A4A4A4]" }, "모프", -1))
const _hoisted_41 = { class: "flex-row" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-1 border-[#E3E6EA] border-b border-solid my-3" }, null, -1))
const _hoisted_43 = { class: "flex" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "w-12 text-[#A4A4A4]" }, "정보", -1))
const _hoisted_45 = { class: "text-[#676767]" }
const _hoisted_46 = { class: "whitespace-pre-wrap text-[#101010] text-base w-full px-4 sm:px-0" }
const _hoisted_47 = { class: "text-end text-sub text-sm mr-4 mt-4" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-zinc-50 w-full h-1 my-8" }, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mr-1" }, " <", -1))
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full lg:h-40 h-20" }, null, -1))

import { computed, onMounted, ref, watchEffect , watch} from 'vue';
import { useStore } from 'vuex';
import { timeForToday } from '@/utils/timeForToday';
import { formattedPrice, formattedGender, sellingStatus } from '@/utils/formattedUnit';
import { useRouter, useRoute } from 'vue-router';
import { getUserId  } from '@/utils/Functions';
import LoadingCircle from '../UI/LoadingCircle.vue';
import SuggestModal from './SuggestModal.vue';
import ConfirmModal from '../UI/ConfirmModal.vue';
import { encodeBase62 , decodeBase62 } from '@/utils/idConverter'
import { SearchApi } from '@/api/api';
import { Swiper, SwiperSlide } from 'swiper/vue';
import GoQRcode from '../UI/GoQRcode.vue';
import 'swiper/css';
import 'swiper/css/navigation';
import SwiperCore, {Pagination,  Autoplay } from "swiper";
import { useMeta } from 'vue-meta';
  interface PostItem {
  image_cnt: number;
  [key: string]: any; // 다른 동적 속성을 위한 인덱스 시그니처
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AdoptDetail',
  setup(__props) {

SwiperCore.use([ Pagination,  Autoplay,  ]);

const store = useStore();
const router = useRouter();
const route = useRoute();
// const postId = route.params.encodedId
const postId = decodeBase62(route.params.encodedId)
const showAppDownloadPopup = ref(false);
const appDownloadLink = ref('');
const postItem = computed(() => store.state.clickedAdopt || []) ;
// const postItem = computed(() => store.getters.getClickedPost || []) ;
const isLoading = computed(() => store.state.isLoading);
const selectedFlag = ref<string>(postItem.value.del_flag.toString() || "0")
const isOpen = ref(false)
const handleModal = () => {
    isOpen.value = !isOpen.value;
}   
const backBtn = () => {
  if (window.history.length > 2) {
    router.go(-1);
  } else {
    router.push('/reptile');
  }
}

const isLastSlide = computed(() => {
    return currentSlide.value === imgArr.value.length - 1;
});
const currentSlide = ref(0);
const onSlideChange = (swiper) => {
    currentSlide.value = swiper.realIndex; // 현재 슬라이드 인덱스 업데이트
};
const updateFlag = async () => {
    const userId = getUserId();
    try{
        await SearchApi.updateDelFlag(postId, selectedFlag.value, userId);
    }catch(error) {
        console.log(error)
    }
    finally{
        isOpen.value = false;
        await store.dispatch('viewAdopt', encodeBase62(postId));
    }
};

const imgArr = computed(() => {
    const post = postItem.value as PostItem; 
    const urls = [];
    for (let i = 1; i < post.image_cnt; i++) {
        const url = post[`imgURL${i}`] as string;
        // console.log(url)
        if (url) {
        urls.push(url);
        }
    }
    return urls;
});
watchEffect(()=> {
    useMeta({
        title: '파충류 다 있다 | 세상의 모든 파충류는 여기에!',
        meta: [
            // { vmid: 'description', property: 'description', content: 'test' },
            // { vmid: 'keywords', property: 'keywords', content: 'test' },
            // { vmid: 'og:title', property: 'og:title', content: 'test'},
            // { vmid: 'og:image', property: 'og:image', content: 'test' },
            { vmid: 'description', property: 'description', content: postItem.value.content },
            { vmid: 'keywords', property: 'keywords', content: postItem.value.detail },
            { vmid: 'og:title', property: 'og:title', content: postItem.value.title },
            { vmid: 'og:image', property: 'og:image', content: postItem.value.imgURL1 },
        ] 
    })
})

const shareContent = async () => {
    if (navigator.share) {
        try {
            await navigator.share({
                text: `${postItem.value.title}\n${formattedPrice(postItem.value.price)}원 \n${document.location.href}`,
            });
            // console.log("성공적으로 공유되었습니다.");
        } catch (error) {
            console.error("공유하기 실패:", error);
        }
  }
};


onMounted( async () => {
    const userAgent = navigator.userAgent;

// 안드로이드 사용자 확인
if (/android/i.test(userAgent)) {
    showAppDownloadPopup.value = true;
    appDownloadLink.value = 'https://play.google.com/store/apps/details?id=com.piot.pada2023&pcampaignid=web_share';
}
// 아이폰 사용자 확인
else if (/iPad|iPhone|iPod/.test(userAgent) ) {
    showAppDownloadPopup.value = true;
    appDownloadLink.value = 'https://apps.apple.com/kr/app/파충류-다-있다/id6465895467';
}
});
const handlePopup = () => {
    showAppDownloadPopup.value = false
}


const spliteDetail = (detail) => {
    let caclRst;
    if(!detail){
        return;
    }
    // if(detail.include(',')){
        caclRst = detail.split(',')
    // }
    const result = caclRst
    // console.log(result)
    return result;
}

//토큰으로 post_id & user_id 비교
const checkUserId = () => {
    const userId = getUserId();
    // console.log(userId) // undefined

    const postUser = postItem.value.user_id;
    if(userId === postUser) return true;
}

const editPost = () => {
    router.push(`/reptile/${encodeBase62(postId)}/edit`);
}        




return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(LoadingCircle)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Swiper), {
            onSlideChange: onSlideChange,
            loop: false,
            navigation: {
                enabled: true,
                nextEl: '.swiper-button-next-custom',
                prevEl: '.swiper-button-prev-custom'
            },
            pagination: { 
                clickable: true, 
                el: '.swiper-pagination', 
            },
            class: "w-full sm:h-160 h-100"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", {
                class: "swiper-button-prev-custom w-8 h-8 absolute top-1/2 left-3 justify-center flex items-center cursor-pointer",
                style: _normalizeStyle([{"z-index":"999"}, imgArr.value.length > 1 ? '' : 'display: none'])
              }, _hoisted_7, 4), [
                [_vShow, currentSlide.value !== 0]
              ]),
              _withDirectives(_createElementVNode("div", {
                class: "swiper-button-next-custom w-8 h-8 absolute top-1/2 right-3 justify-center flex items-center cursor-pointer",
                style: _normalizeStyle([{"z-index":"999"}, imgArr.value.length > 1 ? '' : 'display: none'])
              }, _hoisted_10, 4), [
                [_vShow, !isLastSlide.value]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgArr.value, (post) => {
                return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: post }, {
                  default: _withCtx(() => [
                    (postItem.value.del_flag === 9 || postItem.value.del_flag === 7)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("div", _hoisted_13, _toDisplayString(postItem.value.del_flag === 9 ? '판매완료' : '예약중'), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("a", {
                      href: post,
                      target: "_blank"
                    }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("img", {
                          src:  post ,
                          alt: "",
                          class: "w-full object-cover sm:rounded-lg"
                        }, null, 8, _hoisted_16)
                      ])
                    ], 8, _hoisted_14)
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              _hoisted_17
            ]),
            _: 1
          }, 8, ["navigation", "pagination"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("img", {
                src: postItem.value.img !== 'b' ? postItem.value.img : require('@/assets/img/logo/defaultProfile.svg'),
                alt: "",
                class: "w-full h-full rounded-full object-cover"
              }, null, 8, _hoisted_21)
            ]),
            _createTextVNode(" " + _toDisplayString(postItem.value.name), 1)
          ]),
          (checkUserId())
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", {
                  class: "border-[#A3A7B0] border border-solid cursor-pointer text-sm flex justify-center items-center sm:w-[7.5rem] sm:h-11 font-bold rounded-md text-[#646669] sm:pe-2 w-16 h-8",
                  onClick: editPost
                }, [
                  _hoisted_23,
                  _createTextVNode(" 글수정 ")
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "cursor-pointer text-sm sm:hidden flex justify-center items-center sm:w-[7.5rem] sm:h-11 font-bold rounded-md text-[#646669] sm:pe-2 w-8 h-8",
                onClick: shareContent
              }, _hoisted_25))
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("h1", _hoisted_28, _toDisplayString(postItem.value.title), 1),
            (checkUserId())
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedFlag).value = $event)),
                    onChange: handleModal,
                    class: "border-[#A3A7B0] border border-solid rounded-md pl-2"
                  }, _hoisted_33, 544), [
                    [_vModelSelect, selectedFlag.value]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("h2", _hoisted_34, _toDisplayString(_unref(formattedPrice)(postItem.value.price)) + "원", 1)
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("p", _hoisted_38, _toDisplayString(postItem.value.jong), 1)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(spliteDetail(postItem.value.detail), (item) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: item.id,
                  style: {"word-break":"break-all"},
                  class: "text-[#676767]"
                }, _toDisplayString(`${ item }, `), 1))
              }), 128))
            ])
          ]),
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _createElementVNode("p", _hoisted_45, _toDisplayString(postItem.value.rsex !== 9 ? `${_unref(formattedGender)(postItem.value.rsex)} •` : '') + " " + _toDisplayString(postItem.value.size ? `${postItem.value.size} •` : '') + " " + _toDisplayString(postItem.value.location), 1)
          ])
        ]),
        _createElementVNode("p", _hoisted_46, _toDisplayString(postItem.value.content), 1),
        _createElementVNode("p", _hoisted_47, _toDisplayString(_unref(timeForToday)(postItem.value.created_at)), 1),
        _hoisted_48,
        _createElementVNode("div", {
          class: "border border-solid border-[#d8d9dc] text-sub w-20 h-8 text-xs justify-center flex items-center rounded-md mt-4 cursor-pointer ml-4 sm:ml-0",
          onClick: backBtn
        }, [
          _hoisted_49,
          _createTextVNode(" 목록으로 ")
        ]),
        _createVNode(GoQRcode),
        (showAppDownloadPopup.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
              _createVNode(SuggestModal, {
                storeUrl: appDownloadLink.value,
                onClosePopup: handlePopup
              }, null, 8, ["storeUrl"])
            ]))
          : _createCommentVNode("", true),
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
              _createVNode(ConfirmModal, {
                content1: `게시글을 ${_unref(sellingStatus)(selectedFlag.value)}로 처리할까요?`,
                okayButton: "확인",
                closeButton: "닫기",
                onUpdateClose: handleModal,
                onUpdateOkay: updateFlag
              }, null, 8, ["content1"])
            ]))
          : _createCommentVNode("", true),
        _hoisted_52
      ]))
}
}

})